// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1737":"c34b1458","3587":"ed9f0b3b","5112":"c34b1458"}[chunkId] + ".chunk.css";
};